import React from "react";
import { Container, Grid, makeStyles } from "@material-ui/core";
import AccountBalanceIcon from "@material-ui/icons/BusinessOutlined";
import PeopleIcon from "@material-ui/icons/PeopleOutline";
import VideoIcon from "@material-ui/icons/FeaturedVideoOutlined";
import EmailIcon from "@material-ui/icons/EmailOutlined";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { Routes } from "../constants/Routes";

function DashboardEmpty(props: RouteComponentProps) {
  const classes = useStyles();

  function navigateTo(path: string) {
    props.history.push(path);
  }

  return (
    <div className="main-container">
      <Container maxWidth="md" className={classes.container}>
        <h1 className={classes.title}>
          Thank you for choosing EmpathiHR. <br></br>To get started lets begin
          by completing the following steps.
        </h1>
        <Grid container spacing={5}>
          <Grid item sm={6} xs={12}>
            <div
              className={classes.gridItem}
              onClick={() => navigateTo(Routes.adminCompanySetupInfo)}
            >
              <AccountBalanceIcon className={classes.icon} />
              <p className={classes.gridStep}>Step 1</p>
              <h3 className={classes.gridTitle}>Setup my company</h3>
            </div>
          </Grid>
          <Grid item sm={6} xs={12}>
            <div className={classes.gridItemInactive}>
              <PeopleIcon className={classes.icon} />
              <p className={classes.gridStep}>Step 2</p>
              <h3 className={classes.gridTitle}>Import my employees</h3>
            </div>
          </Grid>
          <Grid item sm={6} xs={12}>
            <div className={classes.gridItemInactive}>
              <VideoIcon className={classes.icon} />
              <p className={classes.gridStep}>Step 3</p>
              <h3 className={classes.gridTitle}>Assign some training</h3>
            </div>
          </Grid>
          <Grid item sm={6} xs={12}>
            <div className={classes.gridItemInactive}>
              <EmailIcon className={classes.icon} />
              <p className={classes.gridStep}>Step 4</p>
              <h3 className={classes.gridTitle}>Send message</h3>
            </div>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default withRouter(DashboardEmpty);

const useStyles = makeStyles({
  container: {
    paddingTop: 40,
    textAlign: "center",
    color: "white",
    minHeight: "100vh",
    background: "#1ea3f8"
  },
  title: {
    marginBottom: 64,
    color: "white"
  },
  icon: {
    height: 40,
    width: 40
  },
  gridItem: {
    border: "3px solid rgba(255,255,255,1)",
    textAlign: "center",
    padding: "45px 0",
    borderRadius: 4,
    backgroundColor: "rgba(255,255,255,0.1)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.2)"
    }
  },
  gridItemInactive: {
    border: "3px solid rgba(255,255,255,0.5)",
    textAlign: "center",
    padding: "45px 0",
    borderRadius: 4,
    backgroundColor: "rgba(255,255,255,0.1)"
  },
  gridStep: {
    color: "white",
    marginBottom: 0
  },
  gridTitle: {
    color: "white",
    marginTop: 0
  }
});
